import Typography from '@mui/material/Typography';
import { t } from 'i18next';
import React from 'react';

const LivePage = () => {
  return (
    <>
      <Typography variant="h4" sx={{ my: 4 }}>
        {t('common.reconciliation')}
      </Typography>
    </>
  );
};

export default LivePage;
